import React from 'react'

// app inputs
import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'
import AppFormikRadio from 'utlis/helpers/forms/AppFormikRadio'

// date picker
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

// day picker moment
import {
    formatDate,
    parseDate,
} from 'react-day-picker/moment';

import moment from 'moment';

export default function Purchasability(props) {
    // props
    const {
        formik
    } = props

    // consts
    const FORMAT = "YYYY-MM-DD"

    // disabling key press
    const handleKeyDown = ev => {
        ev.preventDefault()
        return false
    }

    // handle expiry date change
    const handleDateChange = value => {
        if (value) {
            const selectedDate = new Date(value)
            let date = selectedDate.getDate()
            let month = selectedDate.getMonth() + 1
            let year = selectedDate.getFullYear()

            let finalDate = `${year}-${month}-${date}`

            // setting the expiry date value in the hidden input
            formik.setFieldValue("purchasabilityPreOrderDate", finalDate)
        }
    }

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* heading */}
                    <p className="box-heading st-fs-18 st-fw-600 st-text-color mb-2">Purchasability</p>


                    <div className="shipping-rates-form-items">
                        {/* radio */}
                        <label className="st-custom-radio d-inline-flex mb-3">
                            <input
                                type="radio"
                                className="d-none"
                                value="1"
                                name="purchasabilityStatus"
                                checked={formik.values.purchasabilityStatus === "1"}
                                onChange={formik.handleChange}

                            />
                            <span className="round mt-0"><span className="inner"></span></span>
                            {/* text */}
                            <span className="text media-body st-text-dark">
                                <span className="head d-block">This product can be purchased in my online store</span>
                            </span>
                        </label> <br />

                        {/* radio */}
                        <label className="st-custom-radio d-inline-flex mb-3">
                            <input
                                type="radio"
                                className="d-none"
                                value="2"
                                name="purchasabilityStatus"
                                checked={formik.values.purchasabilityStatus === "2"}
                                onChange={formik.handleChange}

                            />
                            <span className="round mt-0"><span className="inner"></span></span>
                            {/* text */}
                            <span className="text media-body st-text-dark">
                                <span className="head d-block">This product cannot be purchased in my online store</span>
                            </span>
                        </label> <br />

                        {
                            formik.values.purchasabilityStatus === "2" ? (
                                <div className="pre-order-form position-relative" style={{ top: -5 }}>
                                    <div className="mb-2">
                                        <p className="mb-1 st-text-color">Show message instead of the price</p>
                                        <AppFormikRadio
                                            formik={formik} // formik object
                                            labelClass={"align-items-center mb-0"} // class name for main wrapper
                                            checkedText={"Enabled"} // name when the radio is checked
                                            unCheckedText={"Disabled"} // name when the radio is checked
                                            // isRequired={true} // is this field is required or not to show the red star sign
                                            formikFieldName={"purchasabilityCallForPrice"} // important: formik value name for the input
                                        />
                                    </div>
                                    {
                                        formik.values.purchasabilityCallForPrice ? (
                                            <AppFormikInput
                                                inputType={"text"}
                                                formik={formik} // formik object
                                                stFormClass={"lt mb-2"} // class name for main wrapper
                                                labelName={"Message"} // label name
                                                // isRequired={true} // is this field is required or not to show the red star sign
                                                placeholder={"Message"} // placeholder for the input
                                                formikFieldName={"purchasabilityCallForLabel"} // important: formik value name for the input
                                            />
                                        ) : null
                                    }
                                </div>
                            ) : null
                        }

                        {/* radio */}
                        <label className="st-custom-radio d-inline-flex">
                            <input
                                type="radio"
                                className="d-none"
                                value="3"
                                name="purchasabilityStatus"
                                checked={formik.values.purchasabilityStatus === "3"}
                                onChange={formik.handleChange}

                            />
                            <span className="round mt-0"><span className="inner"></span></span>
                            {/* text */}
                            <span className="text media-body st-text-dark">
                                <span className="head d-block">This product is coming soon but I want to take pre-orders</span>
                            </span>
                        </label>

                        {
                            formik.values.purchasabilityStatus === "3" ? (
                                <div className="pre-order-form d-flex flex-wrap">
                                    {/* form field */}
                                    <AppFormikInput
                                        inputType={"text"}
                                        formik={formik} // formik object
                                        stFormClass={"lt"} // class name for main wrapper
                                        labelName={"Message"} // label name
                                        // isRequired={true} // is this field is required or not to show the red star sign
                                        placeholder={"Message"} // placeholder for the input
                                        formikFieldName={"purchasabilityPreOrderMessage"} // important: formik value name for the input
                                    />

                                    <div className="st-form rt">
                                        <label>Release Date</label>
                                        <DayPickerInput
                                            onDayChange={handleDateChange}
                                            value={formik.values.purchasabilityPreOrderDate ?? new Date()}
                                            inputProps={{
                                                className: 'form-control',
                                                onKeyDown: handleKeyDown
                                            }}
                                            classNames={{ container: 'date-picker-container' }}
                                            dayPickerProps={{
                                                todayButton: 'Today',
                                                disabledDays: { before: moment().add(1, "days").toDate() }
                                            }}
                                            formatDate={formatDate}
                                            format={FORMAT}
                                            parseDate={parseDate}
                                            placeholder={"YYYY-MM-DD"}
                                            disabledDays={{ daysOfWeek: [0] }}

                                        // showOverlay={true}
                                        // hideOnDayClick={false}
                                        // keepFocus={true}
                                        />

                                        <input
                                            type="text"
                                            className="form-control d-none"
                                            placeholder="Expiry Date"
                                            id="purchasabilityPreOrderDate"
                                            {...formik.getFieldProps('purchasabilityPreOrderDate')} />
                                        {
                                            /* form message */
                                            (formik.touched.purchasabilityPreOrderDate && formik.errors.purchasabilityPreOrderDate) && (
                                                <div className="st-form-msg position-absolute">
                                                    <p className="st-fs-12">{formik.errors.purchasabilityPreOrderDate}</p>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            ) : null
                        }
                    </div>

                </div>
            </div>
        </React.Fragment>
    )
}
